import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';
import type { Id } from '../../../convex/_generated/dataModel';
import { useConvexMutation } from '../use-convex-mutation';

export interface ParentSummary {
  id: string;
  email: string;
  childrenCount: number;
  createdAt: number;
}

type RelationshipType = "mother" | "father" | "guardian" | "grandparent";

export function useDirectorParents() {
  const data = useQuery(api.director.parents.list);
  return { data, isLoading: data === undefined, error: null };
}

export function useParentChildren(parentId: string) {
  const data = useQuery(
    api.director.parents.getChildren,
    parentId ? { parentUserId: parentId as Id<"users"> } : 'skip'
  );
  return { data, isLoading: data === undefined, error: null };
}

export function useLinkChild() {
  const { mutateAsync, isPending } = useConvexMutation(api.director.parents.linkChild);
  return {
    isPending,
    mutateAsync: (args: { parentId: string; playerId: string; relationshipType?: string }) =>
      mutateAsync({ parentUserId: args.parentId as Id<"users">, playerId: args.playerId as Id<"players">, relationshipType: args.relationshipType as RelationshipType | undefined }),
  };
}

export function useUnlinkChild() {
  const { mutateAsync, isPending } = useConvexMutation(api.director.parents.unlinkChild);
  return {
    isPending,
    mutateAsync: (args: { parentId: string; playerId: string }) =>
      mutateAsync({ parentUserId: args.parentId as Id<"users">, playerId: args.playerId as Id<"players"> }),
  };
}
